import React, { useState } from 'react';
import { TextField, Button, Box, Grid, Select, InputLabel, MenuItem } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import DateAdapter from '@material-ui/pickers';
import "./stepper.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepConnector from "@material-ui/core/StepConnector";
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';

import clsx from "clsx";
import PropTypes from 'prop-types';
import Check from '@material-ui/icons/Check';
import { FormControl } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import Niu from '../MainNav'
import PasoUnoForm from './PasoUnoForm'
import PasoDosForm from './PasoDosForm'
import PasoTresForm from './PasoTresForm'
import useStyles  from './useStyles'

/* define los colores de los iconos segun estado, activo o si aun no llega a ese paso  */
const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center'
  },

  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },

  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

/* metodo para customizar el background color de las lineas entre iconos, en este caso contiene una gradiante */
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

/* metodo para customizar el color de los iconos y su emplazamiento dentro de su contenedor */
const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  
  },
  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
});

/* metodo para customización de los iconos del stepper */
function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  /* aquí se definen los iconos que llevara el stepper */
  const icons = {
    1: <AssignmentTurnedInIcon />,
    2: <AssignmentTurnedInIcon />,
    3: <AssignmentTurnedInIcon />,

  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};




const StepperTemplate = props => {

  const [activeStep, setActiveStep] = useState(0);

  /* con el array steps, controlo la cantidad de pasos que tendrá, se puede dejar como '' si no se quiere mostrar */
  const steps = ['Paso 1', 'Paso 2', 'Paso 3']
  const classes = useStyles();

  const [tituloH1, setTitiloH1] = useState('Guía de Servicios')
  const [titulo, setTitulo] = useState('Solicitud De Mediación Para Controversias Con Isapre Y Fonasa')
  const [nombreRuta, setNombreRuta] = useState('Servicios')
  const [valorButton, setvalorButton] = useState('Siguiente')


  const history = useHistory();

  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return (
          <PasoUnoForm/>
        )
      case 1:
        return (
          <PasoDosForm/>
          )
      case 2:
        return (
          <PasoTresForm/>
          )
      default:
        return 'Paso incorrecto';
    }
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  };

  const handleBack = () => {

    setActiveStep((prevActiveStep) => prevActiveStep - 1)

  };

  const handleNavClick = () => {
    console.log('poner aqui la navegacion')
    
  }

  const handleEnviar = () => {
    console.log("enviando")
  };
   



  return (

    <>
      {/* el componente de navegacion */}
      <Niu titulo={tituloH1} nombreRuta={nombreRuta} handleNavClick={handleNavClick}></Niu>

      {/* el contenedor del formulario */}
      <div className={classes.contenedorForm + ' shadow'}  >

        <div>
          <h2 style={{ fontSize: 26 }} className="py-2">{titulo}</h2>

        </div>
        <div className={classes.root}>

        <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel >{label}</StepLabel>
                </Step>
              ))}
        </Stepper>

        <div>
            {/*  acá se cargan las vistas de los elementos de formulario segun el paso en el que se esté, sería conveniente 
            crear componentes para cada paso */}
            {getStepContent(activeStep)}

            {/* aquí se pueden modificar los botones para avanzar o retroceder, dependiendo del valor del active step se pueden 
            hacer varias cosas curiosas */
            
            
            }
            <Box display="flex" justifyContent="space-between">

              <Grid style={{ marginLeft: 40, marginBottom: 20, paddingTop: 10 }}>
                
                
                  
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleBack}
                      hidden={activeStep === 0}
                    >
                      Atrás
                    </Button>
                
              </Grid>
          
              
              <Grid style={{ marginRight: 40, marginBottom: 20, paddingTop: 10 }}>
                
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNext}
                      hidden={activeStep === steps.length - 1}
                    >
                    {valorButton}
                    </Button>
         

              
                
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleEnviar}
                    hidden={activeStep !== steps.length - 1}
                  >
                  Enviar
                  </Button>
              </Grid>


            </Box>
          </div>

        </div>
        <div>

        </div>
      </div>

    </>

  );
}
export default StepperTemplate;
